import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import querystring from 'query-string';
import { spaces } from '../../../assets/styles/themes/tokens';
import { Subject, numberOfSlides, routes } from '../../../constants';
import { getProductsBySubjectId, getProductsBySubjectIdStatus } from '../../../reducers/dashboard.selectors';
import { SearchFilters, SearchResultsTab } from '../../../types/search';
import useRouter from '../../../utils/useRouter';
import DashboardMuiCard from '../../cards/MuiCard/DashboardMuiCard';
import NewCarousel from '../../Carousel/NewCarousel';
import { getCommonCardProps } from '../../Search/SearchResults/SearchResults';
import { AsyncActionStatus } from '../../../actions/common.actionTypes';
import CardSkeleton from '../../Carousel/CardSkeleton';

interface OwnProps {
  subject: Subject;
}

const SubjectCarousel: React.FC<OwnProps> = ({ subject }) => {
  const { t } = useTranslation();
  const { router } = useRouter();
  const products = useSelector(state => getProductsBySubjectId(state, subject.id));
  const loadingStatus = useSelector(state => getProductsBySubjectIdStatus(state, subject.id));
  const slides = new Array(numberOfSlides.xl).fill(null);

  const onShowAllClick = () => {
    const searchParams: SearchFilters = {
      subject: [subject.id],
      sortBy: 'createdDate'
    };

    const qs = querystring.stringify(searchParams, { skipNull: true });
    const uri = `/${routes.search.root}/${SearchResultsTab.PRODUCTS}?${qs}`;
    router.push(uri);
  };
  
  return (
    <Box sx={{
      paddingTop: spaces.md,
      paddingBottom: spaces.xxxxl,
      display: 'flex',
      flexDirection: 'column',
      gap: spaces.lg,
    }}>
      <NewCarousel 
        title={t('New in {subject}', { subject: subject.text })}
        slidesCount={products.length}
        onShowAll={onShowAllClick}
      >
        {
          loadingStatus === AsyncActionStatus.READY ? (
            products.map((product) => (
              <DashboardMuiCard 
                key={product.id}
                {...getCommonCardProps({ ...product, type: 'product' })}
                contentType='product' 
              />
            ))
          )
            : slides.map((_, index) => <CardSkeleton key={index} />)
        }
      </NewCarousel>
    </Box>
  );
};

export default SubjectCarousel;
